module.exports = __webpack_public_path__ + "media/src/img/about-banner-ef28b5da6b3fc31c5122039a236e24a3.png";